(function () {
  // Store the original cart icon SVG only (not the count bubble)
  let originalCartIconSVG = null;

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function formatMoney(el, cents) {
    const symbolMatch = (el?.textContent || "").match(/[£$€]/);
    const symbol = symbolMatch ? symbolMatch[0] : "£";
    return symbol + (cents / 100).toFixed(2);
  }

  function saveCartIcon() {
    if (originalCartIconSVG) return; // Already saved
    
    const cartLink = document.querySelector('a[href="/cart"], #cart-icon-bubble, .cart-icon-bubble');
    if (!cartLink) return;

    // Find ONLY the SVG icon, not the count bubble
    const iconSVG = cartLink.querySelector('svg:not(.cart-count-bubble svg)');
    if (iconSVG) {
      originalCartIconSVG = iconSVG.cloneNode(true);
      console.log("[CART] Saved original cart icon SVG");
    }
  }

  function restoreCartIcon() {
    if (!originalCartIconSVG) return;
    
    const cartLink = document.querySelector('a[href="/cart"], #cart-icon-bubble, .cart-icon-bubble');
    if (!cartLink) return;

    // Find the current SVG (not inside cart-count-bubble)
    const currentSVG = cartLink.querySelector(':scope > svg, .icon svg, .cart-icon svg');
    
    if (currentSVG) {
      // Check if it's different from our saved one
      if (currentSVG.outerHTML !== originalCartIconSVG.outerHTML) {
        currentSVG.replaceWith(originalCartIconSVG.cloneNode(true));
        console.log("[CART] Restored original cart icon SVG");
      }
    }
  }

  async function updateCartCount() {
    const res = await fetch("/cart.js?" + Date.now());
    const cart = await res.json();
    console.log("[CART] Item count:", cart.item_count);

    const bubble = document.querySelector(".cart-count-bubble");
    if (!bubble) return;

    // Show/hide the bubble based on cart count
    bubble.style.display = cart.item_count > 0 ? "" : "none";
    
    // Update the count number
    const countText = bubble.querySelector('[aria-hidden="true"]');
    if (countText) {
      countText.textContent = cart.item_count;
    }
    
    const srText = bubble.querySelector(".visually-hidden");
    if (srText) {
      srText.textContent = `${cart.item_count} items`;
    }
    
    // Restore icon SVG after count update (count bubble is separate)
    restoreCartIcon();
  }

  async function addToCart(variantId, qty = 1, sellingPlanId = null) {
    console.log("[CART] Adding variant:", variantId, "Selling Plan:", sellingPlanId);

    // Save the cart icon before any changes
    saveCartIcon();

    // Build the request body
    const requestBody = { id: variantId, quantity: qty };
    if (sellingPlanId) {
      requestBody.selling_plan = sellingPlanId;
    }

    // Only request cart-drawer section, NOT cart-icon-bubble to preserve the icon
    const res = await fetch(
      "/cart/add.js?sections=cart-drawer",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody)
      }
    );

    if (!res.ok) {
      console.error("[CART] Add failed", await res.text());
      return;
    }

    const data = await res.json();
    console.log("[CART] Added successfully", data);

    const drawer = document.querySelector("cart-drawer");
    
    if (!drawer) {
      window.location.href = "/cart";
      return;
    }

    // Get the sections HTML from the response
    const sections = data.sections;
    
    if (sections && sections['cart-drawer']) {
      // Parse the new cart-drawer HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const newDrawerInner = doc.querySelector('.drawer__inner');
      const currentDrawerInner = drawer.querySelector('.drawer__inner');
      
      if (newDrawerInner && currentDrawerInner) {
        // Replace just the inner content
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        console.log("[CART] Drawer content updated");
      } else if (newDrawerInner) {
        // If current inner doesn't exist, replace entire drawer content
        const newDrawer = doc.querySelector('cart-drawer');
        if (newDrawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          console.log("[CART] Full drawer content replaced");
        }
      }
      
      // Remove the is-empty class if present
      drawer.classList.remove('is-empty');
      
      // Wait for DOM to settle
      await new Promise(requestAnimationFrame);
      await new Promise(requestAnimationFrame);
      await sleep(100);
      
      // Now safely open the drawer
      try {
        if (typeof drawer.open === 'function') {
          drawer.open();
          console.log("[CART] Drawer opened via open()");
        } else {
          // Manual fallback
          drawer.setAttribute('open', '');
          drawer.classList.add('active', 'animate');
          document.body.classList.add('overflow-hidden');
          console.log("[CART] Drawer opened manually");
        }
      } catch (e) {
        console.warn("[CART] Error opening drawer:", e);
        // Try manual open as fallback
        drawer.setAttribute('open', '');
        drawer.classList.add('active', 'animate');
        document.body.classList.add('overflow-hidden');
      }
      
      // Restore cart icon SVG after drawer opens
      await sleep(50);
      restoreCartIcon();
      
    } else {
      // Fallback: use renderContents if no sections data
      console.log("[CART] No sections data, using renderContents fallback");
      if (drawer.renderContents) {
        try {
          drawer.renderContents(data);
          await sleep(150);
          drawer.open();
        } catch (e) {
          console.error("[CART] renderContents failed:", e);
          window.location.href = "/cart";
        }
      } else {
        window.location.href = "/cart";
      }
    }

    // Update the count number (this won't touch the icon SVG)
    updateCartCount();
    
    // Final restore after everything settles
    await sleep(200);
    restoreCartIcon();
  }

  function initTabs() {
    document.querySelectorAll(".tab-btn").forEach(btn => {
      btn.addEventListener("click", () => {
        const target = btn.dataset.target;
        console.log("[TABS] Switch to:", target);

        document.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
        document.querySelectorAll(".tab-content").forEach(c => c.classList.remove("active"));

        btn.classList.add("active");
        document.getElementById(target)?.classList.add("active");
      });
    });

    // Check URL query parameter for tab activation (e.g., ?tab=filters for Product 2)
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab')?.toLowerCase();

    if (tabParam === 'filters' || tabParam === 'refills' || tabParam === 'product-2') {
      // Find the second tab button (Product 2 / Filter Refills)
      const tabButtons = document.querySelectorAll(".tab-btn");
      if (tabButtons.length >= 2) {
        const secondTabBtn = tabButtons[1];
        const target = secondTabBtn.dataset.target;

        // Remove active from all tabs
        document.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
        document.querySelectorAll(".tab-content").forEach(c => c.classList.remove("active"));

        // Activate second tab
        secondTabBtn.classList.add("active");
        document.getElementById(target)?.classList.add("active");

        console.log("[TABS] Activated Product 2 tab via URL param:", tabParam);
      }
    }
  }

  function getFilterText(input) {
    const spans = input.closest(".variant-label")?.querySelectorAll(".blue-small");
    const text = spans?.[1]?.textContent?.trim() || null;
    console.log("[P1] Filter selected:", text);
    return text;
  }

  function getColorText(input) {
    const label = input.closest(".color-rect")?.querySelector("label");
    if (!label) return null;

    const rawNode = Array.from(label.childNodes)
      .find(n => n.nodeType === 3 && n.textContent.trim());

    const text = rawNode ? rawNode.textContent.trim() : null;
    console.log("[P1] Color selected:", text);
    return text;
  }

  function getProduct1Variant(tab) {
    if (!window.product1Data) return null;

    const filterInput = tab.querySelector(".product-1-filters input:checked");
    const colorInput = tab.querySelector(".product-1-colors input:checked");
    if (!filterInput || !colorInput) return null;

    const filter = getFilterText(filterInput);
    const color = getColorText(colorInput);

    console.group("[P1] MATCH ATTEMPT");
    console.log("Looking for:");
    console.log("option1 (Color)  ===", JSON.stringify(color));
    console.log("option2 (Filter) ===", JSON.stringify(filter));

    const variant = window.product1Data.variants.find(v => {
      const match = v.option1 === color && v.option2 === filter;
      console.log(
        "Check:",
        JSON.stringify(v.option1),
        JSON.stringify(v.option2),
        "→",
        match ? "✅ MATCH" : "❌"
      );
      return match;
    });

    console.groupEnd();
    console.log("[P1] Matched variant:", variant);
    return variant || null;
  }

  function updateProduct1Price(tab) {
    const v = getProduct1Variant(tab);
    const priceEl = tab.querySelector(".price-1");
    if (!v || !priceEl) {
      console.warn("[P1] Price update failed");
      return;
    }
    priceEl.textContent = formatMoney(priceEl, v.price);
    console.log("[P1] Price updated:", v.price);
  }

  function updateProduct1Image(tab) {
    const colorInput = tab.querySelector(".product-1-colors input:checked");
    if (!colorInput) return;

    const img = tab.querySelector(".product-image.main-image");
    const thumb = tab.querySelector(`.variant-thumb[data-variant-id="${colorInput.value}"]`);

    if (img && thumb?.dataset.full) {
      img.src = thumb.dataset.full;
      console.log("[P1] Image updated:", thumb.dataset.full);
    }
  }

  function getProduct2Variant() {
    const type = document.querySelector(".product-2-filter-type input:checked")?.value;
    const pack = document.querySelector(".product-2-pack-size input:checked")?.value;
    if (!type || !pack) return null;

    const v = window.product2Data?.variants.find(
      x => x.option1 === type && x.option2 === pack
    );
    console.log("[P2] Variant:", v);
    return v;
  }

  function updateProduct2Price() {
    const priceEl = document.querySelector(".product-2 .price-1");
    const subscriptionInput = document.querySelector('.subscription-option input');
    const subscriptionOption = document.querySelector('.subscription-option');
    const subscriptionPriceEl = document.querySelector('.subscription-price');

    // Get currently selected filter type
    const filterType = document.querySelector(".product-2-filter-type input:checked")?.value;

    // Update pack size prices based on selected filter type
    if (filterType && window.product2Data) {
      // Update Pack of 1 price
      const pack1Variant = window.product2Data?.variants.find(
        x => x.option1 === filterType && x.option2 === 'Pack of 1'
      );
      const pack1PriceEl = document.querySelector('.pack-price[data-pack="Pack of 1"]');
      if (pack1Variant && pack1PriceEl) {
        pack1PriceEl.textContent = ' - ' + formatMoney(priceEl, pack1Variant.price);
        console.log("[P2] Pack of 1 price updated:", pack1Variant.price);
      }

      // Update Pack of 2 price
      const pack2Variant = window.product2Data?.variants.find(
        x => x.option1 === filterType && x.option2 === 'Pack of 2'
      );
      const pack2PriceEl = document.querySelector('.pack-price[data-pack="Pack of 2"]');
      if (pack2Variant && pack2PriceEl) {
        pack2PriceEl.textContent = ' - ' + formatMoney(priceEl, pack2Variant.price);
        console.log("[P2] Pack of 2 price updated:", pack2Variant.price);
      }

      // Update subscription option price and selling plan
      if (subscriptionOption && subscriptionPriceEl && pack2Variant && pack2Variant.selling_plan_allocations?.length > 0) {
        // Get the subscription price directly from selling_plan_allocations (set in Seal Subscription)
        const allocation = pack2Variant.selling_plan_allocations[0];
        const subscriptionPrice = allocation.price;
        const sellingPlanId = allocation.selling_plan_id;

        // Update selling plan ID on the input
        if (subscriptionInput) {
          subscriptionInput.dataset.sellingPlan = sellingPlanId;
          console.log("[P2] Selling plan updated:", sellingPlanId);
        }

        // Update subscription price display using the price from Seal Subscription settings
        subscriptionPriceEl.textContent = ' - ' + formatMoney(priceEl, subscriptionPrice);
        console.log("[P2] Subscription price updated from allocation:", subscriptionPrice);
      }
    }

    // Check if subscription is selected
    const isSubscriptionSelected = document.querySelector('.subscription-option input:checked');
    if (isSubscriptionSelected && isSubscriptionSelected.value === 'subscription') {
      // Show subscription price from selling_plan_allocations as main price
      const pack2Variant = window.product2Data?.variants.find(
        x => x.option1 === filterType && x.option2 === 'Pack of 2'
      );
      if (pack2Variant && pack2Variant.selling_plan_allocations?.length > 0 && priceEl) {
        const subscriptionPrice = pack2Variant.selling_plan_allocations[0].price;
        priceEl.textContent = formatMoney(priceEl, subscriptionPrice);
        console.log("[P2] Main price updated (subscription):", subscriptionPrice);
      }
    } else {
      // Regular pack selection
      const v = getProduct2Variant();
      if (v && priceEl) {
        priceEl.textContent = formatMoney(priceEl, v.price);
        console.log("[P2] Price updated:", v.price);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Save the original cart icon SVG as soon as page loads
    saveCartIcon();

    updateCartCount();
    initTabs();

    // Initialize Product 2 prices (including subscription price)
    updateProduct2Price();

    // Watch for changes to the cart icon SVG only (not the count bubble)
    const cartLink = document.querySelector('a[href="/cart"], #cart-icon-bubble');
    if (cartLink) {
      const cartIconObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          // Skip if the mutation is inside the cart-count-bubble
          if (mutation.target.closest('.cart-count-bubble')) {
            continue;
          }
          
          // Check if an SVG was added/changed (not the count bubble)
          if (mutation.type === 'childList') {
            const addedSVG = Array.from(mutation.addedNodes).find(
              node => node.nodeName === 'SVG' || (node.querySelector && node.querySelector('svg'))
            );
            if (addedSVG) {
              setTimeout(restoreCartIcon, 10);
              break;
            }
          }
        }
      });

      cartIconObserver.observe(cartLink, {
        childList: true,
        subtree: true
      });
    }

    document.querySelectorAll(".product-section-tabs").forEach(section => {
      section.addEventListener("change", e => {
        const tab = e.target.closest(".tab-content");
        if (!tab) return;

        if (
          e.target.closest(".product-1-filters") ||
          e.target.closest(".product-1-colors")
        ) {
          updateProduct1Price(tab);
        }

        if (e.target.closest(".product-1-colors")) {
          updateProduct1Image(tab);
        }

        if (
          e.target.closest(".product-2-filter-type") ||
          e.target.closest(".product-2-pack-size") ||
          e.target.closest(".subscription-option")
        ) {
          updateProduct2Price();
        }

      });

      section.addEventListener("click", async e => {
        const btn = e.target.closest(".button_design-basket");
        if (!btn) return;

        const tab = btn.closest(".tab-content");
        if (!tab) return;

        if (tab.querySelector(".product-1-filters")) {
          e.preventDefault();
          const v = getProduct1Variant(tab);
          if (!v) return;

          // Store original HTML to preserve SVG
          const originalHTML = btn.innerHTML;
          const svg = btn.querySelector('svg');
          const svgHTML = svg ? svg.outerHTML : '';

          btn.innerHTML = "Adding…" + svgHTML;
          btn.disabled = true;

          try {
            await addToCart(v.id, 1);
          } finally {
            // Always restore button state
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }
        }
      });
    });

    document.querySelector(".product-2 .button_design-basket")
      ?.addEventListener("click", async e => {
        e.preventDefault();

        // Check if subscription is selected from pack-size radio group
        const packSizeInput = document.querySelector('.product-2-pack-size input:checked');
        const subscriptionInput = document.querySelector('.subscription-option input:checked');
        let sellingPlanId = null;
        let variantId = null;

        if (subscriptionInput && subscriptionInput.value === 'subscription') {
          // Subscription selected - use Pack of 2 variant with selling plan
          sellingPlanId = subscriptionInput.dataset.sellingPlan;
          // Get the Pack of 2 variant
          const type = document.querySelector(".product-2-filter-type input:checked")?.value;
          const v = window.product2Data?.variants.find(x => x.option1 === type && x.option2 === 'Pack of 2');
          if (!v) return;
          variantId = v.id;
        } else {
          // Regular purchase
          const v = getProduct2Variant();
          if (!v) return;
          variantId = v.id;
        }

        const btn = e.currentTarget;
        // Store original HTML to preserve SVG
        const originalHTML = btn.innerHTML;
        const svg = btn.querySelector('svg');
        const svgHTML = svg ? svg.outerHTML : '';

        btn.innerHTML = "Adding…" + svgHTML;
        btn.disabled = true;

        try {
          await addToCart(variantId, 1, sellingPlanId);
        } finally {
          // Always restore button state
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }
      });

    // 🔵 Product 1 Thumbnails — match by variant ID
    document.querySelectorAll(".variant-thumb[data-variant-id]").forEach(thumb => {
      thumb.addEventListener("click", () => {
        const tab = thumb.closest(".tab-content");
        if (!tab) return;

        const clickedVariantId = thumb.dataset.variantId;
        const imageURL = thumb.dataset.full;

        console.group("[P1] Thumbnail Clicked");
        console.log("thumbnail variant-id:", clickedVariantId);
        console.log("thumbnail image URL:", imageURL);

        // Update main image
        const mainImg = tab.querySelector(".product-image.main-image");
        if (mainImg && imageURL) {
          mainImg.src = imageURL;
          console.log("Main image set to:", imageURL);
        }

        // Select matching color radio
        const radio = tab.querySelector(
          `.product-1-colors input[value="${clickedVariantId}"]`
        );

        if (radio) {
          console.log("Selecting color radio for variant:", clickedVariantId);
          radio.checked = true;
          // trigger price and image update logic
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          console.warn("No matching color radio for this thumbnail.");
        }

        console.groupEnd();
      });
    });

  });
})();